/** 获取a标签 */
export const getATags = (html) => {
    if (!html) return []

    const links = html.querySelectorAll("a")
    return links ?? []
}
